export default "__VITE_ASSET__B4g$1XgW__"